import type { MutationUpdaterFn } from '@apollo/client';

import type * as Schema from 'src/types/graphql';

export const updateCacheUpdateApproachability: MutationUpdaterFn<
  Schema.UpdateApproachabilityMutation
> = (cache, { data }) => {
  const _id = data?.updateApproachability?.viewer?._id || '';
  const approachability =
    data?.updateApproachability?.viewer?.approachability || null;

  cache.modify({
    id: cache.identify({
      __typename: 'Candidate',
      _id,
    }),
    fields: {
      approachability: () => approachability,
    },
  });
};

export const generateUpdateApproachabilityOptimisticResponse =
  ({ _id }: { _id: string }) =>
  ({
    approachability: { approachable },
  }: Schema.UpdateApproachabilityMutationVariables) => ({
    __typename: 'Mutation',
    updateApproachability: {
      ref: _id,
      __typename: 'UpdateApproachabilityPayload',
      viewer: {
        _id,
        __typename: 'Candidate',
        approachability: { __typename: 'Approachability', approachable },
      },
    },
  });
